module.exports = __webpack_public_path__ + "img/oj_icon.d7d9a123.png";